export const comments_5150486 = {"data":{"data":[],"links":{}}}